import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class ClientPOCExportSearchParams extends SearchParamsBase {
  static saveType = 'ClientPOCExportSearchParams';
  initialize() {
    this.OfficeId = null;
    this.ClientIsActive = '';
  }
}
